/**
 * Validation for min length
 *
 * @param {Number} length
 */
export const minLengthValidation = length => value =>
    value && value.length < length ? ['validation.error.min', { min: length }] : '';



// WEBPACK FOOTER //
// ./src/utils/minLengthValidation.js